// extracted by mini-css-extract-plugin
module.exports = {"ytPlayerWrapper":"GroupAppYoutube_ytPlayerWrapper__2PGAg","ytPlayer":"GroupAppYoutube_ytPlayer__Xo8AM"};